<template>
  <footer class="footer">
    <div class="container">
      Todos los derechos reservados | © 2025 Fundación Apoyo <br>
      <a href="https://fundacionapoyo.com/wp-content/uploads/2023/04/Politica-para-Tratamiento-de-datos-personales.pdf" target="_blank" style="color: white; font-size: 12px;">Política de protección de datos</a>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FooterComponent',
  props: { }
}
</script>
